import React, { useEffect, useState } from "react";
import { Dropdown } from "semantic-ui-react";

import useAuth from "../../login/AuthContext";
import Api from "../../../services/Api";

export const NetworksField = ({ networks, updateNetworks, editable }) => {
  const [networkSearch, setNetworkSearch] = useState({
    filter: null,
    networks: [],
  });
  const { getAuthToken } = useAuth();

  async function doNetworkSearch(filter) {
    const networkSearchResponse = await Api.searchForNetworkByName(
      filter,
      networks.map((x) => x.value),
      await getAuthToken()
    );

    setNetworkSearch({
      ...networkSearch,
      networks: networkSearchResponse.networks.map((x) => ({
        key: x.id,
        text: x.name,
        value: x.id,
      })),
    });
  }

  useEffect(() => {
    if (!networkSearch.filter) {
      return;
    }

    const handler = setTimeout(() => {
      if (networkSearch.filter.length >= 3) {
        doNetworkSearch(networkSearch.filter);
      }
    }, 250);

    return () => clearTimeout(handler);
  }, [networkSearch.filter]);

  useEffect(() => {
    setNetworkSearch({ ...networkSearch, networks });
  }, [networks]);

  const options = networkSearch.networks.length > 0 ? networkSearch.networks : networks;

  return (
    <div>
      Networks:
      <Dropdown
        placeholder="Enter network name"
        fluid
        search
        selection
        multiple
        options={options}
        value={networks.map((x) => x.key)}
        disabled={!editable}
        onSearchChange={(e, data) => {
          setNetworkSearch({ ...networkSearch, filter: e.target.value });
        }}
        onChange={(e, optionsObj) => {
          const selectedNetworks = optionsObj.value;
          const fullNetworkInfo = networkSearch.networks.filter((x) => selectedNetworks.includes(x.key));

          updateNetworks(fullNetworkInfo);
        }}
      />
    </div>
  );
};
